import React, { lazy } from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Navigation } from 'lucide-react';
import { Button } from './ui/Button';
export function LocalSEO() {
  return <section className="py-24 bg-white border-t border-gray-100" data-id="element-307">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-308">
        <div className="text-center mb-10" data-id="element-309">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-310">
            Nationwide Service, Local Expertise
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-311">
            Based in Indiana, we serve businesses, schools, and organizations
            across the United States with reliable production, fast turnaround,
            and consistent quality.
          </p>
        </div>

        <div className="bg-gradient-to-r from-gray-900 to-gray-800 rounded-2xl overflow-hidden shadow-2xl" data-id="element-312">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-0" data-id="element-313">
            {/* Google Maps Embed */}
            <div className="relative h-64 lg:h-auto bg-gray-700" data-id="element-314">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d381655.02125268657!2d-85.83935475429354!3d41.64105098022174!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88165a302a088877%3A0xf44ce14d635fb135!2sWear%20Haus%20Designs!5e0!3m2!1sen!2sus!4v1768498100010!5m2!1sen!2sus" width="100%" height="100%" style={{
              border: 0
            }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Wear Haus Designs Location Map" data-id="element-315" />
            </div>

            {/* Content */}
            <div className="p-12 flex flex-col justify-center text-white" data-id="element-316">
              <h3 className="text-2xl md:text-3xl font-bold mb-6" data-id="element-317">
                Visit Our{' '}
                <span className="text-wh-yellow" data-id="element-318">Indiana Facility</span>
              </h3>

              <p className="text-gray-300 text-lg mb-6 leading-relaxed" data-id="element-319">
                Our state-of-the-art production facility in LaGrange, Indiana
                serves as the hub for nationwide fulfillment. Local pickup
                available for Indiana customers.
              </p>

              <div className="space-y-4 mb-8" data-id="element-320">
                <div className="flex items-start gap-3" data-id="element-321">
                  <MapPin className="w-5 h-5 text-wh-pink flex-shrink-0 mt-1" data-id="element-322" />
                  <div data-id="element-323">
                    <p className="font-semibold" data-id="element-324">4425 West US 20, Suite 1</p>
                    <p className="text-gray-400" data-id="element-325">LaGrange, Indiana 46761</p>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-326">
                  <Navigation className="w-5 h-5 text-wh-teal flex-shrink-0 mt-1" data-id="element-327" />
                  <div data-id="element-328">
                    <p className="font-semibold" data-id="element-329">Local Pickup Available</p>
                    <p className="text-gray-400" data-id="element-330">
                      Monday–Friday, 8:00 AM to 4:00 PM EST
                    </p>
                  </div>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-4" data-id="element-331">
                <Link to="/Contact" data-id="element-332">
                  <Button variant="primary" data-id="element-333">Contact Us</Button>
                </Link>
                <a href="https://www.google.com/maps/dir//Wear+Haus+Designs,+4425+West+US+20+Suite+1,+LaGrange,+IN+46761" target="_blank" rel="noopener noreferrer" data-id="element-334">
                  <Button variant="secondary" data-id="element-335">Get Directions</Button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}